import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';

const connectPlusState = () => {
    return {
        baseUrl: process.env.VUE_APP_BASE_URL,
        connectPlusRedirects: [],
    };
};

const connectPlusMutations = {
    [storeMutation.setConnectPlusRedirects]: (state, data) => {
        state.connectPlusRedirects = data;
    },
};

const connectPlusActions = {
    [storeAction.getConnectPlusRedirects]: wrapAction(storeAction.getConnectPlusRedirects, ({ state, commit }) => {
        return axios({
            //url: '/mocks/connectRedirects.json',
            url: `${state.baseUrl}communities/api/communities/redirects`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setConnectPlusRedirects, response.data);
                return response.data;
            })

            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
};

const feedbackGetters = {
    [storeGetters.connectPlusRedirects]: state => state.connectPlusRedirects,
};

export default {
    namespaced: true,
    state: {
        initialState: connectPlusState(),
        ...connectPlusState(),
    },
    mutations: { ...connectPlusMutations },
    actions: { ...connectPlusActions },
    getters: { ...feedbackGetters },
};
